export default "__VITE_ASSET__CiAEX5p7__"